import { AppStatus } from "@utils/constants";

export const getTailwindColorFromAppStatus = (appStatus: AppStatus | undefined) => {
  switch (appStatus) {
    case "live":
      return {
        borderColor: "border-green-500",
        backgroundColor: "bg-green-400",
        textColor: "text-white",
      };
    case "draft":
      return {
        borderColor: "",
        backgroundColor: "bg-zinc-400",
        textColor: "text-white",
      };
    case "pending":
      return {
        borderColor: "",
        backgroundColor: "bg-orange-400/80",
        textColor: "text-white",
      };
    case "building":
      return {
        borderColor: "border-orange-400",
        backgroundColor: "bg-orange-400",
        textColor: "text-white",
      };
    default:
      return {
        borderColor: "",
        backgroundColor: "bg-zinc-400",
        textColor: "text-white",
      };
  }
};
